import './style.css'
import ReactDOM from 'react-dom/client'
import { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { KeyboardControls } from '@react-three/drei'
import Interface from './Interface.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
    <KeyboardControls map={[
        {name:'forward', keys:['ArrowUp','KeyW']},
        {name:'backward', keys:['ArrowDown','KeyS']},
        {name:'left', keys:['ArrowLeft','KeyA']},
        {name:'right', keys:['ArrowRight','KeyD']},
        {name:'jump', keys:['Space']},
    ]} >
        <Canvas
            tabIndex={0}
            onPointerDown={(e) => e.target.focus()}
            shadows
            camera={ {
                fov: 45,
                near: 0.1,
                far: 200,
                position: [ 0, 4, 24 ]
            } }
        >
            <Suspense fallback={null}>
                <Experience />
            </Suspense>
        </Canvas>
        <Interface />
    </KeyboardControls>
    
    
    </>
)